module.exports = __webpack_public_path__ + "static/jade8-4bc0ed78f12d1e1b3f0a2f6b4a981eb9.png";